module.exports = __webpack_public_path__ + "static/img/bg_header.a7aabdf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/contractPoint/bg_header.png
// module id = pK/X
// module chunks = 0